import { defineStore } from 'pinia'
import type { FeatureFlag } from '~/utils/isFeatureEnabled'
import { HomeApi } from '~/features/Home/api/homeApi'

export const useMainStore = defineStore('main', () => {
  const featureFlags = ref<FeatureFlag>({})
  const isAppCookieBannerVisible = ref<boolean>(false)

  async function getFeatureFlags() {
    try {
      featureFlags.value = await HomeApi.getFeatureFlags()
    } catch (e) {
      showError(e)
    }
  }

  return {
    featureFlags,
    isAppCookieBannerVisible,
    getFeatureFlags,
  }
})
